import { render } from "./imageSegment.vue?vue&type=template&id=ca30967c"
import script from "./imageSegment.vue?vue&type=script&lang=js"
export * from "./imageSegment.vue?vue&type=script&lang=js"

import "./imageSegment.vue?vue&type=style&index=0&id=ca30967c&lang=scss"

import exportComponent from "C:\\Users\\chbo\\Documents\\repos\\semco-maritime-touchkit\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__